import {
  RunColorOptions,
  SemanticLegendSettings,
  XAxisValues,
  YAxisValues,
} from '../types';
import {SEMANTIC_LEGEND_PALETTE_DEFAULT} from './utils/colorPalettes';
import {getColorFromValue} from './utils/getDefaultBucketColors';

export const xAxisLabels: {[key: string]: string} = {
  ['default']: '',
  [XAxisValues.Step]: 'Step',
  [XAxisValues.RunTime]: 'Relative Time (Process)',
  [XAxisValues.AbsoluteRunTime]: 'Relative Time (Wall)',
  [XAxisValues.Timestamp]: 'Wall Time',
};

// x-axis
export const DEFAULT_X_AXIS_OPTION = {
  value: 'default',
  label: xAxisLabels['default'],
};

export const DEFAULT_X_AXIS_OPTION_VALUES: string[] = [
  XAxisValues.RunTime,
  XAxisValues.AbsoluteRunTime,
  XAxisValues.Timestamp,
  XAxisValues.Step,
];

export const yAxisLabels: {[key: string]: string} = {
  ['']: '',
  [YAxisValues.Min]: 'Min',
  [YAxisValues.Max]: 'Max',
  [YAxisValues.Last]: 'Last',
};

export const DEFAULT_Y_AXIS_OPTION_VALUES: string[] = [
  YAxisValues.Min,
  YAxisValues.Max,
  YAxisValues.Last,
];

export const EMPTY_SETTINGS = {};

// These are the only fields that are guaranteed to be set in the default semantic legend settings
export type DefaultSemanticLegendSettings = SemanticLegendSettings &
  Required<
    Pick<
      SemanticLegendSettings,
      | 'bucketCustomizations'
      | 'buckets'
      | 'excludedRunColor'
      | 'key'
      | 'metricStatistics'
      | 'numberOfBuckets'
      | 'runColorOptions'
      | 'viewID'
      | 'yAxisValue'
    >
  >;

export const DEFAULT_SEMANTIC_LEGEND_SETTINGS: DefaultSemanticLegendSettings = {
  key: DEFAULT_X_AXIS_OPTION.value,
  runColorOptions: RunColorOptions.OriginalProjectColors,
  yAxisValue: YAxisValues.Last,
  numberOfBuckets: 4,
  buckets: [
    {
      bucketMin: 0,
      bucketMax: 100,
      color: getColorFromValue(0, 4, SEMANTIC_LEGEND_PALETTE_DEFAULT),
    },
    {
      bucketMin: 100,
      bucketMax: 200,
      color: getColorFromValue(1, 4, SEMANTIC_LEGEND_PALETTE_DEFAULT),
    },
    {
      bucketMin: 200,
      bucketMax: 300,
      color: getColorFromValue(2, 4, SEMANTIC_LEGEND_PALETTE_DEFAULT),
    },
    {
      bucketMin: 300,
      bucketMax: 400,
      color: getColorFromValue(3, 4, SEMANTIC_LEGEND_PALETTE_DEFAULT),
    },
  ],
  bucketCustomizations: {},
  excludedRunColor: '#D3D7DE',
  metricStatistics: {
    [YAxisValues.Min]: {
      min: 0,
      max: 100,
    },
    [YAxisValues.Max]: {
      min: 400,
      max: 500,
    },
    [YAxisValues.Last]: {
      min: 400,
      max: 500,
    },
    [YAxisValues.Config_Number]: {
      min: 0,
      max: 0,
    },
  },
  viewID: '',
};
